module.exports = __webpack_public_path__ + "img/22.e044b52f.jpg";